export default __webpack_public_path__ + "static/media/paycell-new-logo-04.fc35a0f0.png";